export const isTokenValid = (
  expiresTo: string,
  tokenType?: string
): boolean => {
  try {
    const now = new Date();
    const tokenExpiry = new Date(expiresTo);
    const isValid = tokenExpiry.getTime() > now.getTime();
    return isValid;
  } catch (error) {
    console.error(`Error validating ${tokenType ?? 'token'}:`, error);
    return false;
  }
};
